"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CompactNav = _interopRequireDefault(require("./CompactNav"));

var _Logo = _interopRequireDefault(require("./Logo"));

var _Context = require("./Context");

var _NavItem = require("./NavItem");

var Header = function Header(props) {
  var _props$LinkWrapper = props.LinkWrapper,
      LinkWrapper = _props$LinkWrapper === void 0 ? _NavItem.DefaultLinkWrapper : _props$LinkWrapper;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, props.banner, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('cloud-ui-nav-chrome header', {
      'search-active': props.searchActive
    }),
    ref: props.forwardedRef
  }, /*#__PURE__*/_react["default"].createElement(_CompactNav["default"], {
    inverted: props.inverted
  }), /*#__PURE__*/_react["default"].createElement(LinkWrapper, {
    href: "/",
    className: "cloud-ui-nav-logo-link"
  }, /*#__PURE__*/_react["default"].createElement(_Logo["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cloud-ui-nav horizontal"
  }, props.children)));
};

var _default = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_Context.ContextConsumer, null, function (_ref) {
    var LinkWrapper = _ref.LinkWrapper,
        searchActive = _ref.searchActive,
        banner = _ref.banner;
    return /*#__PURE__*/_react["default"].createElement(Header, (0, _extends2["default"])({}, props, {
      LinkWrapper: LinkWrapper,
      searchActive: searchActive,
      forwardedRef: ref,
      banner: banner
    }));
  });
});

exports["default"] = _default;